import React from "react";

const ArrowCycle = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_1109)">
      <path
        d="M14.6654 7.99992C14.6654 11.9999 11.7387 14.6666 8.12803 14.6666C5.19336 14.6666 2.82536 13.1099 1.9987 10.6666M1.33203 7.99992C1.33203 3.99992 4.2587 1.33325 7.87003 1.33325C10.804 1.33325 13.1707 2.88992 13.9987 5.33325"
        stroke="#02C9A6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66536 11.3333L1.9987 10.6666L1.33203 13.3333M11.332 4.6666L13.9987 5.33326L14.6654 2.6666"
        stroke="#02C9A6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_1109">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ArrowCycle;
